import { render, staticRenderFns } from "./CreateCard.vue?vue&type=template&id=f6acd8dc&scoped=true"
import script from "./CreateCard.vue?vue&type=script&lang=ts"
export * from "./CreateCard.vue?vue&type=script&lang=ts"
import style0 from "./CreateCard.vue?vue&type=style&index=0&id=f6acd8dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6acd8dc",
  null
  
)

export default component.exports